<script setup>
const props = defineProps({
	src: {
		type: String,
		required: true,
	},
	alt: {
		type: String,
		required: true,
	},
})
</script>

<template>
	<div class="w-fit bg-white p-1 pb-10">
		<img class="aspect-video h-44" :src="src" :alt="alt" />
	</div>
</template>
